import {NormalizedItem, Request, Resource} from 'simpli-web-sdk'
import {TipoVeiculoCollection} from '../collection/TipoVeiculoCollection'

export class TipoVeiculo extends Resource {
  idTipoVeiculo: number = 0
  nome: string | null = null
  ativo: boolean = false

  get $id() {
    return this.idTipoVeiculo
  }
  set $id(val) {
    this.idTipoVeiculo = val
  }

  get $nome() {
    return String(this.nome)
  }
  set $nome(val) {
    this.nome = val
  }
  get $ativo() {
    return this.ativo
  }
  set $ativo(val: boolean) {
    this.ativo = val
  }

  static validateXlsxItem(item: NormalizedItem<any>) {
    if (Object.keys(item).length == 0 || item == null) return false
    if (
      !/\d/g.test(item.idTipoVeiculo) ||
      !item.nome ||
      !item.ativo ||
      !/^(0|1){1}$/g.test(item.ativo)
    ) {
      // Desse jeito é possivel eu dar o erro com o número da linha na View
      if (!/\d/g.test(item.idTipoVeiculo)) {
        throw 'invalidIdTipoVeiculo'
      } else if (!item.idTipoVeiculo) {
        throw 'invalidNome'
      } else if (!item.nome) {
        throw 'invalidNome'
      } else if (!/^(0|1){1}$/g.test(item.ativo)) {
        // O regex ^(0|1){1}$ só aceita 1 caracter podendo ser 0 ou 1
        throw 'invalidAtivo'
      }
      return false
    }
    return true
  }

  static buildFromXlsx(item: NormalizedItem<any>): TipoVeiculo | null {
    if (!this.validateXlsxItem(item)) return null
    const tipoVeiculo = new TipoVeiculo()
    tipoVeiculo.idTipoVeiculo = parseInt(item.idTipoVeiculo)
    tipoVeiculo.nome = item.nome as string
    tipoVeiculo.ativo = item.ativo == '1'
    return tipoVeiculo
  }

  async listTipoVeiculo() {
    return await Request.get(`/admin/tipo-veiculo`)
      .name('listTipoVeiculo')
      .as(TipoVeiculoCollection)
      .getData()
  }
  async listCsvTipoVeiculo() {
    return await Request.get(`/admin/tipo-veiculo/csv`)
      .name('listCsvTipoVeiculo')
      .as(this)
      .getData()
  }

  async updateTipoVeiculoById(id: number) {
    return await Request.patch(`/admin/tipo-veiculo/${id}`, this)
      .name('updateTipoVeiculoById')
      .as(this)
      .getData()
  }

  async deleteTipoVeiculoById(id: number) {
    return await Request.delete(`/admin/tipo-veiculo/${id}`)
      .name('deleteTipoVeiculoById')
      .as(this)
      .getData()
  }

  async persist() {
    return await Request.post(`/admin/tipo-veiculo/persist`, this)
      .name('persist')
      .as(this)
      .getData()
  }

  async tipoVeiculocCsvgenerator() {
    return await Request.get(`/admin/tipo-veiculo/csv`)
      .name('tipoVeiculocCsvgenerator')
      .as(TipoVeiculoCollection)
      .getData()
  }

  async getTipoVeiculoById(id: number) {
    return await Request.get(`/admin/tipo-veiculo/${id}`)
      .name('getTipoVeiculoById')
      .as(this)
      .getData()
  }
}
